import { render, staticRenderFns } from "./student-payments.vue?vue&type=template&id=2f5e2459&scoped=true&"
import script from "./student-payments.vue?vue&type=script&lang=js&"
export * from "./student-payments.vue?vue&type=script&lang=js&"
import style0 from "./student-payments.vue?vue&type=style&index=0&id=2f5e2459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5e2459",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCard,VDataTable,VIcon,VImg,VTextField})
